// api/staffApi.js
import axios from "axios";

const BASE_URL = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/staff-auth`,
});

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

// ➕ Register New Staff

export async function registerStaff(payload) {
  try {
    const res = await BASE_URL.post(`/staff/register`, payload, getHeaders());
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 📖 Get All Staff (paginated + filtered) — GET with query params
export async function getAllStaff(payload) {
  try {
    const {
      n_page = 1,
      n_limit = 10,
      c_search_term = "",
      c_role = "",
      c_department = "",
      c_field_role = "",
      c_org_id = "",
      c_zone_id = "",
    } = payload || {};

    const res = await BASE_URL.get(`/staff/get`, {
      ...getHeaders(),
      params: {
        n_page,
        n_limit,
        c_search_term,
        c_role,
        c_department,
        c_field_role,
        c_org_id,
        c_zone_id,
      },
    });
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}

// 👤 Get Staff by ID
export async function getStaffById(id) {
  try {
    const res = await BASE_URL.get(`/staff/${id}`, getHeaders());
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}

// ✏️ Update Staff
export async function updateStaff(id, payload) {
  try {
    const res = await BASE_URL.put(
      `/staff/update/${id}`,
      payload,
      getHeaders(),
    );
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}

// 🗑️ Delete Staff
export async function deleteStaff(id) {
  try {
    const res = await BASE_URL.delete(`/staff/delete/${id}`, getHeaders());
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}

// 🔄 Toggle Active Status
export async function toggleStaffStatus(id) {
  try {
    const res = await BASE_URL.patch(`/staff/toggle/${id}`, {}, getHeaders());
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}
// 💰 Set Base Salary for a staff (one-time setup, ADMIN only)
// PATCH /api/staff-auth/staff/base-salary/:id   Body: { baseSalary }
export async function setBaseSalary(id, baseSalary) {
  try {
    const res = await BASE_URL.patch(
      `/staff/base-salary/${id}`,
      { baseSalary },
      getHeaders(),
    );
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}

// 🔗 Get logged-in BDE's own driver-invite link + incentive total
// GET /api/staff-auth/staff/my-invite-link
export async function getMyInviteLink() {
  try {
    const res = await BASE_URL.get(`/staff/my-invite-link`, getHeaders());
    return res.data;
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || err.message,
    };
  }
}

// 🔐 2FA (Google Authenticator) — Staff
export async function setupStaffTwoFactor() {
  try {
    const res = await BASE_URL.post(`/staff/2fa/setup`, {}, getHeaders());
    return res.data;
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
}

export async function verifyStaffTwoFactorSetup(payload) {
  try {
    const res = await BASE_URL.post(
      `/staff/2fa/verify-setup`,
      payload,
      getHeaders(),
    );
    return res.data;
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
}

export async function disableStaffTwoFactor(payload) {
  try {
    const res = await BASE_URL.post(
      `/staff/2fa/disable`,
      payload,
      getHeaders(),
    );
    return res.data;
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
}

// public — no auth header, called from Login.jsx step 2
export async function loginStaffVerifyTOTP(payload) {
  try {
    const res = await BASE_URL.post(`/staff/login/verify-totp`, payload);
    return res.data;
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || err.message,
    };
  }
}
